.connect-button-container > * {
    margin-top: 16px;
    width: 350px;
}
